import Box from "@mui/material/Box";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { format, parseISO } from "date-fns";
import { forwardRef, useMemo } from "react";
import { Availability } from "src/api/types";

interface Props {
  value: Date | null;
  availability: Availability;
  onChange: (d: Date | null) => void;
}

const toKey = (d: Date) => format(d, "yyyy-MM-dd");

const DateSlide = forwardRef<HTMLDivElement, Props>(
  ({ value, availability, onChange, ...rest }, ref) => {
    const availableDates = useMemo(
      () =>
        new Set(
          Object.keys(availability).filter((d) => availability[d]?.length),
        ),
      [availability],
    );

    const firstAvailable = useMemo(() => {
      const sorted = [...availableDates].sort();
      return sorted.length ? parseISO(sorted[0]) : new Date();
    }, [availableDates]);

    return (
      <Box ref={ref} sx={{ position: "absolute", inset: 0 }} {...rest}>
        <DateCalendar
          value={value}
          defaultValue={firstAvailable}
          onChange={onChange}
          disablePast
          shouldDisableDate={(d) => !availableDates.has(toKey(d))}
          sx={{ width: "100%" }}
        />
      </Box>
    );
  },
);

export default DateSlide;
